

// import React, { useEffect, useState, useCallback } from 'react';
// import axios from 'axios';
// // import { Loader } from 'lucide-react';
// import LoaderButton from './pageLoaders/LoaderButton';
// // Note: If you have a central axios instance configured with base URLs/interceptors, use that instead.
// const api = axios.create({
//   baseURL: process.env.REACT_APP_CHAT_MICROSERVICE_URL || '', // Adjust based on your env
// });

// const FormTemplate = ({ 
//   formType, 
//   formData, 
//   setFormData, 
//   showPriority = true,
//   onValidationChange ,
//   token,
//   uniquePartnerId
// }) => {
//   const [formTemplate, setFormTemplate] = useState(null);
//   const [slaPolicyLabel, setSlaPolicyLabel] = useState('Low');
//   const [loading, setLoading] = useState(true);
//   const [isPolicyLoading, setIsPolicyLoading] = useState(false);
//   const [validationErrors, setValidationErrors] = useState({});

//   /**
//    * 1. Fetch Form Template on Moun
//    */
// useEffect(() => {
//     const fetchTemplate = async () => {
//       try {
//         setLoading(true);
//         const response = await api.get(`/public/form-template/type/${formType}?uniquePartnerId=${uniquePartnerId}`, {
//           headers: {
//             Authorization: `Bearer ${token}`
//           }
//         });

//         // FIX: The API returns an object with a "formTemplateData" array
//         const allTemplates = response.data?.data?.formTemplateData || [];
        
//         // Find the active template, or fall back to the first one if none are marked active
//         const template = allTemplates.find(t => t.isActive === true) || allTemplates[0];

//         if (template) {
//           setFormTemplate(template);

//           // Initialize default values
//           const initialData = { ...formData };
//           template.fields.forEach(field => {
//             if (initialData[field.name] === undefined || initialData[field.name] === null) {
//               initialData[field.name] = field.defaultValue || '';
//             }
//             // Handle Cascader initial child value
//             if (field.fieldType === 'cascader' && field.options?.length) {
//               const parent = initialData[field.name] || field.defaultValue || '';
//               const childFieldName = `sub_${field.name}`;
//               const childOptions = field.options.find(p => p.value === parent)?.children || [];
//               if (childOptions.length > 0 && initialData[childFieldName] === undefined) {
//                 initialData[childFieldName] = childOptions[0].value;
//               }
//             }
//           });
//           setFormData(initialData);
//         } else {
//           console.warn("No templates found for type:", formType);
//         }
//       } catch (error) {
//         console.error("Error fetching form template:", error);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchTemplate();
//   }, [formType]);
//   /**
//    * 2. Fetch Matched SLA Policy whenever formData changes
//    */
//   useEffect(() => {
//     const fetchSlaPolicy = async () => {
//       if (!formData || Object.keys(formData).length === 0) return;
      
//       try {
//         setIsPolicyLoading(true);
//         const response = await api.patch(`/public/custom-sla/policy-match/${formType}?uniquePartnerId=${uniquePartnerId}`, { 
//           fields: formData 
//         },{
//                 headers:{
//                 Authorization: `Bearer ${token}`
//             }
//         });
//         setSlaPolicyLabel(response.data?.data || 'Low');
//       } catch (error) {
//         console.error("Error matching SLA policy:", error);
//       } finally {
//         setIsPolicyLoading(false);
//       }
//     };

//     const debounceTimer = setTimeout(fetchSlaPolicy, 500); // Debounce to prevent too many API calls
//     return () => clearTimeout(debounceTimer);
//   }, [formData, formType]);

//   /**
//    * 3. Validation Logic
//    */
//   const validateForm = useCallback(() => {
//     if (!formTemplate) return;
//     const errors = {};
//     let isValid = true;

//     formTemplate?.fields?.forEach(field => {
//       if (field.required) {
//         const value = formData[field.name];
//         if (value === undefined || value === null || value === '') {
//           errors[field.name] = `${field.label} is required`;
//           isValid = false;
//         } else if (field.fieldType === 'cascader') {
//           const childFieldName = `sub_${field.name}`;
//           const childValue = formData[childFieldName];
//           if (childValue === undefined || childValue === null || childValue === '') {
//             errors[childFieldName] = `Sub-category is required`;
//             isValid = false;
//           }
//         }
//       }
//     });

//     setValidationErrors(errors);
//     if (onValidationChange) onValidationChange(isValid);
//   }, [formData, formTemplate, onValidationChange]);

//   useEffect(() => {
//     validateForm();
//   }, [formData, validateForm]);

//   const handleChange = e => {
//     const { name, value, type, checked } = e.target;
//     setFormData(prev => ({
//       ...prev,
//       [name]: type === 'checkbox' ? checked : value,
//     }));

//     if (validationErrors[name]) {
//       setValidationErrors(prev => ({ ...prev, [name]: '' }));
//     }
//   };

//   const renderField = field => {
//     const commonProps = {
//       id: field.name,
//       name: field.name,
//       value: formData[field.name] || '',
//       onChange: handleChange,
//       className: `dexkor-form-input ${validationErrors[field.name] ? 'border-red-500' : ''}`,
//       required: field.required,
//       placeholder: field.label,
//     };

//     switch (field.fieldType) {
//       case 'text':
//       case 'email':
//       case 'number':
//         return (
//           <div className="dexkor-field-group">
//             <input type={field.fieldType} {...commonProps} />
//             {validationErrors[field.name] && <p className="error-text">{validationErrors[field.name]}</p>}
//           </div>
//         );
//       case 'textarea':
//         return (
//           <div className="dexkor-field-group">
//             <textarea {...commonProps} className={`dexkor-form-input-textarea ${validationErrors[field.name] ? 'border-red-500' : ''}`} rows={3} />
//             {validationErrors[field.name] && <p className="error-text">{validationErrors[field.name]}</p>}
//           </div>
//         );
//       case 'select':
//         return (
//           <div className="dexkor-field-group">
//             <select {...commonProps} className="dexkor-form-select">
//               <option value="">{field.defaultValue || `Select ${field.label}`}</option>
//               {(field.options || []).map(opt => <option key={opt._id} value={opt.value}>{opt.label}</option>)}
//             </select>
//             {validationErrors[field.name] && <p className="error-text">{validationErrors[field.name]}</p>}
//           </div>
//         );
//       case 'cascader':
//         const selectedParent = formData[field.name] || '';
//         const childOptions = field.options.find(p => p.value === selectedParent)?.children || [];
//         const selectedChild = formData[`sub_${field.name}`] || '';

//         return (
//           <div className="dexkor-cascader-wrapper">
//              <select
//                 name={field.name}
//                 value={selectedParent}
//                 onChange={e => setFormData(prev => ({ ...prev, [field.name]: e.target.value, [`sub_${field.name}`]: '' }))}
//                 className="dexkor-form-select mb-2"
//               >
//                 <option value="">Select Category</option>
//                 {field.options.map(opt => <option key={opt.value} value={opt.value}>{opt.label}</option>)}
//               </select>
//               <select
//                 name={`sub_${field.name}`}
//                 value={selectedChild}
//                 onChange={handleChange}
//                 disabled={!selectedParent}
//                 className="dexkor-form-select"
//               >
//                 <option value="">Select Sub-category</option>
//                 {childOptions.map(child => <option key={child.value} value={child.value}>{child.label}</option>)}
//               </select>
//           </div>
//         );
//       default:
//         return null;
//     }
//   };

//   return (
//     <div className="w-full">
//       {formTemplate?.fields?.sort((a, b) => a.order - b.order).map(field => (
//         <div key={field._id} className="field-row">
//           <label className="field-label">{field.label} {field.required && <span className="star">*</span>}</label>
//           {renderField(field)}
//         </div>
//       ))}
      
//       {showPriority && (
//         <div className="">
//           <label className="block text-sm text-start font-medium text-gray-700 text-start">Expected Priority</label>
//           <div >
//             <input value={slaPolicyLabel} readOnly                 className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none"
// />
//             {isPolicyLoading && <div className="spinner-small" />}
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };
// export default FormTemplate;

import React, { useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import LoaderButton from './pageLoaders/LoaderButton';

const api = axios.create({
  baseURL: process.env.REACT_APP_CHAT_MICROSERVICE_URL || '',
});

const FormTemplate = ({ 
  formType, 
  formData, 
  setFormData, 
  showPriority = false,
  onValidationChange,
  token,
  uniquePartnerId
}) => {
  const [formTemplate, setFormTemplate] = useState(null);
  const [slaPolicyLabel, setSlaPolicyLabel] = useState('Low');
  const [loading, setLoading] = useState(true);
  const [isPolicyLoading, setIsPolicyLoading] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});

  useEffect(() => {
    const fetchTemplate = async () => {
      try {
        setLoading(true);
        const response = await api.get(`/public/form-template/type/${formType}?uniquePartnerId=${uniquePartnerId}`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        const allTemplates = response.data?.data?.formTemplateData || [];
        const template = allTemplates.find(t => t.isActive === true) || allTemplates[0];

        if (template) {
          setFormTemplate(template);
          const initialData = { ...formData };
          template.fields.forEach(field => {
            if (initialData[field.name] === undefined || initialData[field.name] === null) {
              initialData[field.name] = field.defaultValue || '';
            }
            if (field.fieldType === 'cascader' && field.options?.length) {
              const parent = initialData[field.name] || field.defaultValue || '';
              const childFieldName = `sub_${field.name}`;
              const childOptions = field.options.find(p => p.value === parent)?.children || [];
              if (childOptions.length > 0 && initialData[childFieldName] === undefined) {
                initialData[childFieldName] = childOptions[0].value;
              }
            }
          });
          setFormData(initialData);
        }
      } catch (error) {
        console.error("Error fetching form template:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchTemplate();
  }, [formType]);

  useEffect(() => {
    const fetchSlaPolicy = async () => {
      if (!formData || Object.keys(formData).length === 0) return;
      try {
        setIsPolicyLoading(true);
        const response = await api.patch(`/public/custom-sla/policy-match/${formType}?uniquePartnerId=${uniquePartnerId}`, 
          { fields: formData },
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setSlaPolicyLabel(response.data?.data || 'Low');
      } catch (error) {
        console.error("Error matching SLA policy:", error);
      } finally {
        setIsPolicyLoading(false);
      }
    };
    const debounceTimer = setTimeout(fetchSlaPolicy, 500);
    return () => clearTimeout(debounceTimer);
  }, [formData, formType]);

  const validateForm = useCallback(() => {
    if (!formTemplate) return;
    const errors = {};
    let isValid = true;
    formTemplate?.fields?.forEach(field => {
      if (field.required) {
        const value = formData[field.name];
        if (!value) {
          errors[field.name] = `${field.label} is required`;
          isValid = false;
        } else if (field.fieldType === 'cascader') {
          if (!formData[`sub_${field.name}`]) {
            errors[`sub_${field.name}`] = `Sub-category is required`;
            isValid = false;
          }
        }
      }
    });
    setValidationErrors(errors);
    if (onValidationChange) onValidationChange(isValid);
  }, [formData, formTemplate, onValidationChange]);

  useEffect(() => { validateForm(); }, [formData, validateForm]);

  const handleChange = e => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
    if (validationErrors[name]) setValidationErrors(prev => ({ ...prev, [name]: '' }));
  };

  const renderField = field => {
    const inputClasses = `w-full px-3 py-1.5 text-sm border rounded-md focus:outline-none focus:ring-1 focus:ring-slate-400 focus:border-slate-400 ${
      validationErrors[field.name] ? 'border-red-500' : 'border-gray-300'
    }`;

    switch (field.fieldType) {
      case 'text':
      case 'email':
      case 'number':
        return (
          <div className="flex flex-col gap-0.5">
            <input type={field.fieldType} name={field.name} value={formData[field.name] || ''} onChange={handleChange} className={inputClasses} placeholder={field.label} />
            {validationErrors[field.name] && <span className="text-xs text-red-500">{validationErrors[field.name]}</span>}
          </div>
        );
      case 'textarea':
        return (
          <div className="flex flex-col gap-0.5">
            <textarea name={field.name} value={formData[field.name] || ''} onChange={handleChange} className={`${inputClasses} resize-none`} rows={2} placeholder={field.label} />
            {validationErrors[field.name] && <span className="text-xs text-red-500">{validationErrors[field.name]}</span>}
          </div>
        );
      case 'select':
        return (
          <div className="flex flex-col gap-0.5">
            <select name={field.name} value={formData[field.name] || ''} onChange={handleChange} className={inputClasses}>
              <option value="">{field.defaultValue || `Select ${field.label}`}</option>
              {(field.options || []).map(opt => <option key={opt._id} value={opt.value}>{opt.label}</option>)}
            </select>
            {validationErrors[field.name] && <span className="text-xs text-red-500">{validationErrors[field.name]}</span>}
          </div>
        );
      case 'cascader':
        const selectedParent = formData[field.name] || '';
        const childOptions = field.options.find(p => p.value === selectedParent)?.children || [];
        return (
          <div className="flex flex-col gap-1.5">
            <select
              name={field.name}
              value={selectedParent}
              onChange={e => setFormData(prev => ({ ...prev, [field.name]: e.target.value, [`sub_${field.name}`]: '' }))}
              className={inputClasses}
            >
              <option value="">Select Category</option>
              {field.options.map(opt => <option key={opt.value} value={opt.value}>{opt.label}</option>)}
            </select>
            <select
              name={`sub_${field.name}`}
              value={formData[`sub_${field.name}`] || ''}
              onChange={handleChange}
              disabled={!selectedParent}
              className={`${inputClasses} disabled:bg-gray-50`}
            >
              <option value="">Select Sub-category</option>
              {childOptions.map(child => <option key={child.value} value={child.value}>{child.label}</option>)}
            </select>
          </div>
        );
      default: return null;
    }
  };

  if (loading) return <div className="p-4 text-center text-sm text-gray-500">Loading form...</div>;

  return (
    <div className="flex flex-col gap-3 w-full">
      {formTemplate?.fields?.sort((a, b) => a.order - b.order).map(field => (
        <div key={field._id} className="flex flex-col gap-1">
          <label className="text-sm font-medium text-gray-700">
            {field.label} {field.required && <span className="text-red-500">*</span>}
          </label>
          {renderField(field)}
        </div>
      ))}
      
      {showPriority && (
        <div className="flex flex-col gap-1 pt-1">
          <label className="text-sm font-medium text-gray-700">Expected Priority</label>
          <div className="relative">
            <input 
              value={slaPolicyLabel} 
              readOnly 
              className="w-full px-3 py-1.5 border border-gray-300 rounded-md text-sm bg-gray-50 text-gray-600 focus:outline-none"
            />
            {isPolicyLoading && (
              <div className="absolute right-3 top-2 w-4 h-4 border-2 border-blue-500 border-t-transparent rounded-full animate-spin" />
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default FormTemplate;